/**
 *
 * Search Service Actions
 *
 */

import {
  SEARCH_REQUEST,
  NOT_ASKED,
  LOADING,
  SUCCESS,
  FAILURE,
  UPDATE_ALREADY_REQUESTED_TRANSFER,
} from './constants';

/**
 * Kicks off the saga that initiates the request.
 *
 * params :{[key:string]: string}: Params for the search request.
 *
 * withRecentDeposits :string: If true, upon success, we kick off a
 * searchRequest for the apexAccountNumber in the recentDeposits service.
 */
export function searchRequest(params={}) {
  return {
    type: SEARCH_REQUEST,
    params,
  };
}

/**
 * Used by the saga to set the status.
 */
export function notAsked() {
  return {
    type: NOT_ASKED,
  };
}

/**
 * Used by the saga to set the status and store params.
 */
export function loading(params) {
  return {
    type: LOADING,
    params,
  };
}

/**
 * Used by the saga to set the status and store results.
 */
export function success(results) {
  return {
    type: SUCCESS,
    results,
  };
}

/**
 * Used by the saga to set the status and store the error.
 */
export function failure(error) {
  return {
    type: FAILURE,
    error,
  };
}

/**
 * Used by other services to update data about a transfer that has been modified by some PUT/POST/PATCH request.
 * At the time this was written the only such service that does this is the actions service.
 *
 * The api does not return the whole transfer, so we need to interpolate the responses from other services with this one.
 */
export function updateAlreadyRequestedTransfer(transferId, newData) {
  return {
    type: UPDATE_ALREADY_REQUESTED_TRANSFER,
    transferId,
    newData,
  };
}



// WEBPACK FOOTER //
// ./src/services/search/actions.js